module.exports = __webpack_public_path__ + "static/scale-model-of-the-jewish-museum-of-new-jersey-in-newark-new-jersey-bb3777d2ba8a6500f99026df47aa9988.png";